import { obfuscateString } from '@nrdy-marketing-engine/api-fetch';
import vtRequestId from '@nrdy-marketing-engine/api-fetch/src/vt-request-id';
import { track } from '@nrdy-marketing-engine/tracking';

const trackCartInteraction = async (
  category: string,
  target: string,
  label = target,
  metaData = {},
  value?: string
) => {
  try {
    return await track('checkout', {
      category,
      label,
      newrelicMetadata: metaData,
      request_id: vtRequestId(),
      target,
      value: obfuscateString(value),
    });
  } catch (err) {
    typeof window !== 'undefined' && window['newrelic']?.noticeError(err);
  }
};

export default trackCartInteraction;
